import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {WithDevice} from "../../../../core/components/composers/with-device";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {TrapezoidCardTitle} from "../../../../core/components/misc/titles/trapezoid-card-title";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-placeholder.module.scss";

export class EntityScoresWidgetHeaderPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
  shouldRenderHeader: Boolean;
}

export const EntityScoresWidgetHeaderPlaceholder = WithDevice(({shouldRenderHeader}: EntityScoresWidgetHeaderPlaceholderProps) => {
  return shouldRenderHeader ? <>
    <TrapezoidCardTitle className={classNames('scores-placeholder-widget-title-container')}/>
    <div className={classNames(styles.header)}/>
  </> : null
});
